import { useMemo } from 'react';

const parameterPattern = /{{([^}]+)}}/g;

export function useTopicTemplate(
  template: string,
  context?: Record<string, string>,
) {
  const matcher = useMemo(() => {
    return new RegExp(
      template.replace(/\//g, '\\/').replace(parameterPattern, '(?<$1>[^/]+)'),
    );
  }, [template]);

  const topic = useMemo(() => {
    if ([template, context].some((value) => value === undefined)) {
      return;
    }

    return template.replace(
      parameterPattern,
      (_match, parameterName) => context?.[parameterName] ?? '',
    );
  }, [context, template]);

  return [topic, matcher];
}
